export const BD_GET_SUPPLIERNAME_LISTING = "BD_GET_SUPPLIERNAME_LISTING"
export const BD_GET_SUPPLIERNAME_LISTING_SUCCESS = "BD_GET_SUPPLIERNAME_LISTING_SUCCESS"
export const BD_GET_SUPPLIERNAME_LISTING_FAILED = "BD_GET_SUPPLIERNAME_LISTING_FAILED"
